(function () {
  if (typeof document === 'undefined') return;

  const baseUrl = 'https://comnexus-ftc-api.btpro.net';
  const endpoint = baseUrl + '/api/v1/customer/stock-request-notify';

  function createModal() {
    if (document.querySelector('.btpro-notifye-me-modal')) return;

    if (!document.getElementById('btpro-notify-me-styles')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'btpro-notify-me-styles';
      styleEl.textContent = [
        '.btpro-notifye-me-inner .btpro-notifye-me-title{color:#000;}',
        '.btpro-notifye-me-inner .btpro-notifye-me-message{color:#000;opacity:.9;}',
        '.btpro-notifye-me-inner .btpro-notifye-me-legal{color:#000;opacity:.9;}',
        '.btpro-notifye-me-inner .btpro-notifye-me-legal a{font-weight:700;color:#000;}',
        '.btpro-notifye-me-inner .facet-checkbox{',
        '  display:flex; align-items:flex-start; gap:10px; position:relative; padding: 0 0 0 26px;',
        '}',
        '.btpro-notifye-me-inner .facet-checkbox input[type="checkbox"]{',
        '  position:absolute; opacity:0; width:1px; height:1px; left:0; top:0; appearance:none; -webkit-appearance:none;',
        '}',
        '.btpro-notifye-me-inner .facet-checkbox::before{',
        '  content:""; position:absolute; left:0; top:2px; width:16px; height:16px; border:1px solid #9ca3af; border-radius:2px; background:#fff;',
        '}',
        '.btpro-notifye-me-inner .facet-checkbox .icon-checkmark{',
        '  position:absolute; left:1px; top:6px; width:14px; height:10px; color:#000; visibility:hidden;',
        '}',
        '.btpro-notifye-me-inner .facet-checkbox input[type="checkbox"]:checked ~ .icon-checkmark{',
        '  visibility:visible;',
        '}',
        '.btpro-notifye-me-inner .facet-checkbox span{',
        '  font-size:14px; color:#000; line-height:1.4;',
        '}'
      ].join('');
      document.head.appendChild(styleEl);
    }

    const modal = document.createElement('div');
    modal.className = 'btpro-notifye-me-modal';
    modal.style.position = 'fixed';
    modal.style.inset = '0';
    modal.style.background = 'rgba(0,0,0,.5)';
    modal.style.display = 'none';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.style.zIndex = '9999';

    const inner = document.createElement('div');
    inner.className = 'btpro-notifye-me-inner';
    inner.style.background = '#fff';
    inner.style.position = 'relative';
    inner.style.width = '92%';
    inner.style.maxWidth = '640px';
    inner.style.padding = '32px 32px 28px';
    inner.style.boxShadow = '0 10px 30px rgba(0,0,0,.15)';

    // Basit dil tespiti
    var isTR = (document.documentElement.lang || '').toLowerCase().indexOf('tr') === 0;
    var STR = (window.theme && window.theme.strings) || {};
    var titleText = (function () {
      try {
        const productJsonEl = document.querySelector('[data-product-json]');
        if (productJsonEl) {
          const productObj = JSON.parse(productJsonEl.textContent || '{}');
          return productObj?.title || '';
        }
      } catch (e) {}
      return '';
    })() || 'Ürün';

    var heading = titleText || '';

    var desc = STR.notify_me_message || '';

    var emailLabel = STR.notify_me_email_label || '';
    var consentLabel = STR.notify_me_consent_label || '';
    var legalHtmlTemplate = STR.notify_me_legal_html || '';
    var legalText = legalHtmlTemplate.replace('{{ link }}', isTR ? '/pages/gizlilik-politikasi' : '/en/pages/privacy-policy');

    inner.innerHTML = [
      '<button class="btpro-notifye-me-close" aria-label="close" style="position:absolute;right:28px;top:27px;background:transparent;border:none;cursor:pointer;line-height:1;">',
      '  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">',
      '    <path d="M18 6L6 18M6 6l12 12" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>',
      '  </svg>',
      '</button>',
      (heading ? '<h2 class="btpro-notifye-me-title" style="margin:0 0 18px 0;font-size:20px;line-height:1;text-align:center;padding-inline:18px;">' + heading + '</h2>' : ''),
      '<p class="btpro-notifye-me-message" style="margin:0 0 18px 0;color:#000;opacity:.9;text-align:center;">' + desc + '</p>',
      '<div class="btpro-notifye-me-input-wrap" style="margin-bottom:16px;position:relative;">',
      '  <span class="btpro-nm-caption" style="position:absolute;top:6px;left:4px;font-size:10px;line-height:1;color:#6b7280;text-transform:uppercase;letter-spacing:.02em;pointer-events:none;">' + emailLabel + '</span>',
      '  <input id="notifyMeEmail" class="btpro-notifye-me-email" type="email" aria-label="' + emailLabel + '" placeholder="" style="width:100%;min-height:56px;padding:18px 16px 12px;border:1px solid #bdbdbd;border-radius:0;font-size:16px;background:#fff;box-shadow:none;outline:none;" />',
      '</div>',
      '<label class="btpro-notifye-me-consent facet-checkbox" style="margin:10px 0 18px 0;">',
      '  <input type="checkbox" required/>',
      '  <svg class="icon icon-checkmark" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '  <span>' + consentLabel + '</span>',
      '</label>',
      '<div style="display:flex;justify-content:center;">',
      '  <button type="button" class="btpro-notifye-me-submit button" style="background:#000;color:#fff;border:1px solid #000;border-radius:8px;padding:6px 25px;cursor:pointer;font-weight:600;text-transform:capitalize">' + (STR.notify_me || '') + '</button>',
      '</div>',
      '<p class="btpro-notifye-me-legal" style="margin-top:16px;font-size:12px;color:#000;opacity:.8;">' + legalText + '</p>',
      '<div class="btpro-notifye-me-feedback" style="margin-top:10px;font-size:14px;"></div>'
    ].join('');

    modal.appendChild(inner);
    document.body.appendChild(modal);
  }

  let currentVariantGid = '';

  function openModal(variantGid, opts) {
    createModal();
    currentVariantGid = variantGid || '';
    const el = document.querySelector('.btpro-notifye-me-modal');
    const inner = el && el.querySelector('.btpro-notifye-me-inner');

    // Eğer modal daha önce başarı ekranına geçmişse formu yeniden kur
    if (inner && !inner.querySelector('.btpro-notifye-me-email')) {
      var isTR = (document.documentElement.lang || '').toLowerCase().indexOf('tr') === 0;
      var STR = (window.theme && window.theme.strings) || {};
      var titleText = (function () {
        try {
          const productJsonEl = document.querySelector('[data-product-json]');
          if (productJsonEl) {
            const productObj = JSON.parse(productJsonEl.textContent || '{}');
            return productObj?.title || '';
          }
        } catch (e) {}
        return '';
      })() || 'Ürün';
      var heading = titleText || '';
      var desc = STR.notify_me_message || '';
      var emailLabel = STR.notify_me_email_label || '';
      var consentLabel = STR.notify_me_consent_label || '';
      var legalHtmlTemplate = STR.notify_me_legal_html || '';
      var legalText = legalHtmlTemplate.replace('{{ link }}', isTR ? '/pages/gizlilik-politikasi' : '/en/pages/privacy-policy');

      inner.innerHTML = [
        '<button class="btpro-notifye-me-close" aria-label="close" style="position:absolute;right:28px;top:27px;background:transparent;border:none;cursor:pointer;line-height:1;">',
        '  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">',
        '    <path d="M18 6L6 18M6 6l12 12" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>',
        '  </svg>',
        '</button>',
        (heading ? '<h2 class="btpro-notifye-me-title" style="margin:0 0 18px 0;font-size:20px;line-height:1;text-align:center;padding-inline:18px;">' + heading + '</h2>' : ''),
        '<p class="btpro-notifye-me-message" style="margin:0 0 18px 0;color:#000;opacity:.9;text-align:center;">' + desc + '</p>',
        '<div class="btpro-notifye-me-input-wrap" style="margin-bottom:16px;position:relative;">',
        '  <span class="btpro-nm-caption" style="position:absolute;top:6px;left:4px;font-size:10px;line-height:1;color:#6b7280;text-transform:uppercase;letter-spacing:.02em;pointer-events:none;">' + emailLabel + '</span>',
        '  <input id="notifyMeEmail" class="btpro-notifye-me-email" type="email" aria-label="' + emailLabel + '" placeholder="" style="width:100%;min-height:56px;padding:18px 16px 12px;border:1px solid #bdbdbd;border-radius:0;font-size:16px;background:#fff;box-shadow:none;outline:none;" />',
        '</div>',
        '<label class="btpro-notifye-me-consent facet-checkbox" style="margin:10px 0 18px 0;">',
        '  <input type="checkbox" required/>',
        '  <svg class="icon icon-checkmark" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '  <span>' + consentLabel + '</span>',
        '</label>',
        '<div style="display:flex;justify-content:center;">',
        '  <button type="button" class="btpro-notifye-me-submit button" style="background:#000;color:#fff;border:1px solid #000;border-radius:8px;padding:6px 25px;cursor:pointer;font-weight:600;text-transform:capitalize">' + (STR.notify_me || '') + '</button>',
        '</div>',
        '<p class="btpro-notifye-me-legal" style="margin-top:16px;font-size:12px;color:#000;opacity:.8;">' + legalText + '</p>',
        '<div class="btpro-notifye-me-feedback" style="margin-top:10px;font-size:14px;"></div>'
      ].join('');
    }

    // Alanları yeniden seç
    const emailInput = el.querySelector('.btpro-notifye-me-email');
    const titleEl = el.querySelector('.btpro-notifye-me-title');
    const feedback = el.querySelector('.btpro-notifye-me-feedback');
    const messageEl = el.querySelector('.btpro-notifye-me-message');
    if (messageEl) messageEl.textContent = ((window.theme && window.theme.strings && window.theme.strings.notify_me_message) || '');
    if (titleEl && opts && typeof opts.productTitle === 'string' && opts.productTitle.trim()) {
      titleEl.textContent = opts.productTitle.trim();
    }
    if (emailInput) emailInput.value = '';
    if (feedback) feedback.textContent = '';
    el.style.display = 'flex';
    setTimeout(function(){ emailInput && emailInput.focus(); }, 0);
  }

  function closeModal() {
    const el = document.querySelector('.btpro-notifye-me-modal');
    if (el) el.style.display = 'none';
  }

  function computeVariantGidFromPage(fallback) {
    try {
      const productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        const productObj = JSON.parse(productJsonEl.textContent || '{}');
        const sel = productObj?.selected_or_first_available_variant;
        if (sel && (sel.admin_graphql_api_id || sel.id)) {
          return sel.admin_graphql_api_id || ('gid://shopify/ProductVariant/' + sel.id);
        }
      }
    } catch (e) {}
    const idInput = document.querySelector('form[action^="/cart/add"] input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
    if (idInput && idInput.value) {
      return 'gid://shopify/ProductVariant/' + idInput.value;
    }
    return fallback || '';
  }

  function onSubmit(emailOverride) {
    let email = (emailOverride || '').trim();
    const feedback = document.querySelector('.btpro-notifye-me-modal .btpro-notifye-me-feedback');
    const emailEl = document.querySelector('.btpro-notifye-me-modal .btpro-notifye-me-email');
    const consentEl = document.querySelector('.btpro-notifye-me-modal .btpro-notifye-me-consent input[type="checkbox"]');
    if (emailEl) email = (emailEl.value || '').trim();

    if (!consentEl || !consentEl.checked) {
      if (feedback) feedback.style.color = '#c00', feedback.textContent = (((window.theme && window.theme.strings) || {}).notify_me_consent_required || '');
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (feedback) feedback.style.color = '#c00', feedback.textContent = (((window.theme && window.theme.strings) || {}).notify_me_error || '');
      return;
    }

    const variantGid = currentVariantGid || computeVariantGidFromPage('');
    if (!variantGid) {
      if (feedback) feedback.style.color = '#c00', feedback.textContent = (window.theme?.strings?.notify_me_error || '');
      return;
    }

    if (!endpoint) {
      if (feedback) feedback.style.color = '#c00', feedback.textContent = '';
      return;
    }

    const payload = {
      ShopifyProductVariantId: variantGid,
      Email: email
    };

    if (feedback) feedback.style.color = '#555', feedback.textContent = '';
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text().catch(function(){ return ''; });
      })
      .then(function () {
        const inner = document.querySelector('.btpro-notifye-me-inner');
        if (inner) {
          inner.innerHTML = [
            '<button class="btpro-notifye-me-close" aria-label="close" style="position:absolute;right:16px;top:8px;background:transparent;border:none;cursor:pointer;">',
            '  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">',
            '    <path d="M18 6L6 18M6 6l12 12" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>',
            '  </svg>',
            '</button>',
            '<div style="padding:40px 12px;text-align:center;">',
            '  <h2 style="margin:0 0 8px 0;font-size:28px;line-height:1.25;">' + ((((window.theme && window.theme.strings) || {}).notify_me_success) || '') + '</h2>',
            '</div>'
          ].join('');
        }
      })
      .catch(function () {
        if (feedback) feedback.style.color = '#c00', feedback.textContent = (((window.theme && window.theme.strings) || {}).notify_me_error || '');
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      const target = e.target;
      if (target && target.classList && target.classList.contains('btn-notify-me')) {
        e.preventDefault();
        const gid = target.getAttribute('data-variant-gid');
        let productTitle = (target.getAttribute('data-product-title') || '').trim();
        if (!productTitle) {
          const card = target.closest('[data-product-title], .card-wrapper, .product-card, .card, .grid__item');
          if (card) {
            productTitle =
              (card.getAttribute && (card.getAttribute('data-product-title') || '')) ||
              (card.querySelector('.card__heading') && card.querySelector('.card__heading').textContent) ||
              (card.querySelector('.product-card__title') && card.querySelector('.product-card__title').textContent) ||
              (card.querySelector('.product-title') && card.querySelector('.product-title').textContent) ||
              (card.querySelector('.full-unstyled-link') && card.querySelector('.full-unstyled-link').textContent) ||
              '';
            productTitle = (productTitle || '').trim();
          }
        }
        // Üye olsa da olmasa da e‑posta alanını göster
        openModal(gid || '', { hideInput: false, productTitle: productTitle });
        return;
      }
      if (target && target.classList?.contains('btpro-notifye-me-modal')) {
        closeModal();
      }
      if (target && (target.classList?.contains('btpro-notifye-me-close') || target.closest('.btpro-notifye-me-close'))) {
        e.preventDefault();
        closeModal();
      }
      if (target && (target.classList?.contains('btpro-notifye-me-submit') || target.closest('.btpro-notifye-me-submit'))) {
        e.preventDefault();
        onSubmit('');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function init() { bindEvents(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();